import styled from 'styled-components';
import { BackdropProps } from './backdrop.types';

export const BackdropContainer = styled.div<BackdropProps>`
  background-color: ${({ invisible }) => (invisible ? 'transparent' : 'rgba(0, 0, 0, 0.85)')};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: -1;
  -webkit-tap-highlight-color: transparent;
`;
